/**
 * The Comeback Loop mock: tomorrow's case created before they leave, the
 * created case on HQ, the tap debrief, the quick briefing and the texts that
 * bring them back. Opt-in while it is a mock (`pnpm dev:comeback-loop`), so
 * the live flow is untouched with the flag absent.
 */
export function comebackLoopEnabled(
  enabled = import.meta.env.VITE_COMEBACK_LOOP === "1",
) {
  return enabled;
}

/**
 * Mission steps on their own (`VITE_MISSION_STEPS=1`, `pnpm dev:comeback`):
 * the first three missions come as small steps on the laptop, and nothing
 * else changes. The full mock turns them on too.
 */
export function missionStepsEnabled(
  enabled = import.meta.env.VITE_MISSION_STEPS === "1",
) {
  return enabled || comebackLoopEnabled();
}

/** The missions that come as small steps: the first three, from the bank.
 *  From the fourth on, the handler runs the mission from the webchat and the
 *  live screen, debrief and report are exactly as before. */
export const STEPS_MISSIONS = 3;
export function missionStepsOn(
  filedN: number,
  enabled = missionStepsEnabled(),
) {
  return enabled && filedN < STEPS_MISSIONS;
}
